import SearchNoResult from "@website/ticket-ui/common/assets/no-result.png";
import { NoResultPropertiesType } from "@website/ticket-ui/common/components/no-result/types";
import { deepCompare } from "@website/utils/deep-compare";
import Image from "next/image";
import { FC, memo } from "react";

export const NoResult: FC<NoResultPropertiesType> = (properties) => {
  const { query, count } = properties;

  return (
    <div className="my-6 flex flex-col items-center">
      <Image
        alt="no result"
        className="w-[188px]"
        height={146}
        src={SearchNoResult.src}
        width={188}
      />
      <div className="text-subtitle-1 text-on-surface-high-emphasis mt-6">
        نتیجه ای یافت نشد.
      </div>
      <div className="text-caption text-on-surface-medium-emphasis mt-2 px-6 text-center">
        {count && `بیشتر از ${count} مورد را گشتیم اما`}
        نتیجه ای برای
        <span className="text-caption text-on-surface-high-emphasis font-medium">{`"${query}"`}</span>
        پیدا نکردیم.
      </div>
      <div className="text-caption text-on-surface-medium-emphasis mt-2 px-6 text-center">
        با کلمه ی دیگری جستجو کنید.
      </div>
    </div>
  );
};

export default memo(NoResult, deepCompare);
